import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    private titleService: Title,
    private meta: Meta,
  ) {
  }

  getMeta(title: string, description: string, image: string, slug: string): {name: string; content: string}[] {
    return [
      { name: 'og:title', content: title},
      { name: 'og:description', content: description },
      { name: 'og:image', content: image },
      { name: 'og:url', content: `https://funbible.net/${slug}` },
      { name: 'twitter:card', content: image },
      { name: 'og:site_name', content: 'Fun Bible' },
    ];
  }

  setTitle(title: string): void {
    this.titleService.setTitle(title);
    this.meta.updateTag({ property: 'og:title', content: title });
  }

  setDescription(description: string): void {
    const shortDescription = this.getMetaDescription(description).substr(0, 155);
      this.meta.updateTag({name: 'description', content: shortDescription});
      
      this.meta.updateTag({
        property: 'og:description',
        content: shortDescription
      });
      
      this.meta.updateTag({
        property: 'twitter:card',
        content: this.getMetaDescription(description)
      });
  }

  getMetaDescription(metaDescription: string): string {
    return metaDescription.replace('[&hellip;]', '').replace('<p>', '').replace('</p>','').substr(0, 200);
  }
}
